import type { ReactNode } from 'react';
import { ClaimflowEnvironmentBanner } from './ClaimflowEnvironmentBanner';
import { ClaimFlowHeader } from './ClaimFlowHeader';
import { ClaimSearchModal } from './ClaimSearchModal';

interface ClaimFlowLayoutProps {
  children: ReactNode;
}

export function ClaimFlowLayout({ children }: Readonly<ClaimFlowLayoutProps>) {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {/* Only rendered when an ERP registry is not tagged `production`. */}
      <ClaimflowEnvironmentBanner />
      <ClaimFlowHeader />
      <main className="flex-1 overflow-y-auto bg-[#EFF1F6]">
        {children}
      </main>
      {/* "Rechercher un dossier" (mahhp 22861) — opened from the header, so it
          is mounted once here and works on every page using this layout. */}
      <ClaimSearchModal />
    </div>
  );
}
